import { render, staticRenderFns } from "./TextAreaInput.vue?vue&type=template&id=1b69c2f8"
import script from "./TextAreaInput.vue?vue&type=script&lang=ts"
export * from "./TextAreaInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports